"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _EditProfileForm = _interopRequireDefault(require("./EditProfileForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Edit profile dialog
var _default = (0, _BaseInjectors.injectToBaseCreationDialog)(_lodash.default.flowRight(_reactRouterDom.withRouter, (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
})), {
  createForm: _EditProfileForm.default,
  editTitle: 'Modifier profil',
  // Override submit action in BaseCreationDialog
  submitAction: function submitAction(formData) {
    this.props.dispatch({
      type: 'EDIT_PROFILE',
      id: this.props.user.id,
      model: formData,
      history: this.props.history,
      redirectTo: '/profile',
      onSuccess: this.props.close
    });
  }
});
exports.default = _default;